'use client';
import React, { useEffect } from 'react';
import HeaderDefault from '~/components/shared/headers/HeaderDefault';
import FooterFullwidth from '~/components/shared/footers/FooterFullwidth';
import HeaderMobile from '~/components/shared/headers/HeaderMobile';

const initHeaders = (
    <>
        <HeaderDefault />
        <HeaderMobile />
    </>
);

const initFooters = <FooterFullwidth />;

const SUFFIX = 'Rawento';

const PageContainer = ({
    header = initHeaders,
    footer = initFooters,
    title,
    children,
}) => {
    useEffect(() => {
        if (!title) return;
        const normalized = String(title).trim().replace(/\s*\|\s*/g, ' - ');
        document.title = normalized.endsWith(SUFFIX) ? normalized : `${normalized} - ${SUFFIX}`;
    }, [title]);

    return (
        <>
            {header}
            {children}
            {footer}
        </>
    );
};

export default PageContainer;